import { useSelector } from 'react-redux';
import Bots from '../Bots';
import WCABots from '../WCABots';

const BotFlow = () => {
  const { companyConfigData } = useSelector((state) => state.authenticate);

  return companyConfigData?.wabaPartner === 'skalebot' ? <WCABots /> : <Bots />;
};

export default BotFlow;
